<template>
  <div class="application-links" v-bind:class="{ nothing: links.length === 0 }">
    <div class="list">
      <div v-for="app in links" :key="app.id">
        <el-button
          type="text"
          size="mini"
          class="btn-link"
          :icon="icon(app.state)"
          @click="$router.push('/instances/' + app.instanceId + '/' + app.id)"
        >
          {{ app.alias }}
        </el-button>

        <el-button
          type="text"
          size="mini"
          class="btn-link btn-remove"
          icon="el-icon-delete"
          @click.prevent="unlink(app)"
        />
      </div>

      <div class="add">
        <LinkApplication :application="application" :links.sync="links" size="small">Connect Application</LinkApplication>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LinkApplication from './Application'

export default {
  props: {
    application: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    LinkApplication
  },
  data () {
    return {
      links: []
    }
  },
  created () {
    this.load()
  },
  computed: mapState(['applications']),
  methods: {
    icon (state) {
      return state === 'running' ? 'el-icon-connection' : 'el-icon-loading'
    },
    unlink (application) {
      this.$confirm('Removing link will cause this app to be unreachable. Continue?', 'Warning', {
        confirmButtonText: 'Unlink ' + application.alias,
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      }).then(() => {
        this.links = this.links.filter((l) => l.id !== application.id)
        return this.$store.dispatch('unlinkApplication', {
          id: this.application.id,
          linkId: application.id
        })
      }).catch(() => {})
    },
    load () {
      this.$store.dispatch('getApplicationLinks', this.application).then((links) => {
        this.links = links.map((id) => this.applications.find((a) => a.id === id))
      }).catch(() => {})
    }
  },
  watch: {
    application (value) {
      if (value) {
        this.load()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../theme";

  .btn-link {
    max-width: 190px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .btn-remove {
    padding-left: 10px;
    color: $--color-danger;
  }
  .nothing {
    .add {
      text-align: center;
    }
  }
</style>

<style lang="scss">
  @import "../../../theme";

  .application-links {
    .add {
      border-top: 1px solid $--border-color-base;
      margin-top: 10px;
      padding-top: 10px;
    }

    .list {
      .btn-link + .btn-link {
        margin-top: 0;
        margin-left: 0;
      }
      .btn-link {
        margin-bottom: 5px;
        margin-top: 10px;
      }
    }

    &.nothing {
      .add {
        border-top: 0;
        margin-top: 0;
      }
    }
  }
</style>
